import { render, staticRenderFns } from "./StoreCorporationDetail.vue?vue&type=template&id=a3524a1c&scoped=true&"
import script from "./StoreCorporationDetail.vue?vue&type=script&lang=js&"
export * from "./StoreCorporationDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreCorporationDetail.vue?vue&type=style&index=0&id=a3524a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3524a1c",
  null
  
)

export default component.exports